@if (!isDuration15Minutes()) {
  <header 
    class="card__header" 
    [attr.data-header-point-scroll-index]="indexCard()"
  >
    @defer (on viewport) { 
      <img 
        [src]="img()" 
        [attr.alt]="('Imagen' | translate) + ' ' + title()"
        (error)="handleImgError($event)"
      >
    } @placeholder {
      <img 
        src="/assets/imgs/default-custom-route-img.webp" 
        [attr.alt]="('Imagen' | translate) + ' ' + title()"
      >
    }
  </header>
}